export default "__VITE_ASSET__d88ae1d6__"